import React from 'react';
import { iconSize } from '../../../../constants/icon.constants';
import Icon from '../../icon';

const CloseButton = (props): JSX.Element => {
  const { closeModal, isEEActiveOrPreview } = props;
  return (
    <button
      className={`modal-dialog__close-button ${isEEActiveOrPreview ? 'modal-dialog__close-button--ee-active' : ''}`}
      onClick={closeModal}
    >
      <Icon iconName="action-close" size={iconSize.dsk} color={'white'} />
    </button>
  );
};

export default CloseButton;
